<template>
  <waypoints-list></waypoints-list>
</template>

<script>
import waypointsList from './waypointsList'

export default {
 name: 'arrangeModeLeftPanel',

 components: {
   'waypoints-list': waypointsList
 }
}
</script>